import { LangleyHero } from './components/LangleyHero';
import { TownshipVsCity } from './components/TownshipVsCity';
import { BylawFramework } from './components/BylawFramework';
import { LicensingProcess } from './components/LicensingProcess';
import { MarketInsights } from './components/MarketInsights';
import { LangleyCTA } from './components/LangleyCTA';
import { Navbar } from '../../pages/home/components/Navbar';
import { Footer } from '../../pages/home/components/Footer';

export default function LangleySTR() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <LangleyHero />
      <TownshipVsCity />
      <BylawFramework />
      <LicensingProcess />
      <MarketInsights />
      <LangleyCTA />
      <Footer />
    </div>
  );
}
